var swiper = new Swiper(".swiper-container", {
	slidesPerView: 1,
	effect: 'fade',
	loop: true,
	autoplay: {
		delay: 2000,
	 },
	speed: 2000
});

var swiperr = new Swiper(".matchySwiper", {
  navigation: {
    nextEl: ".matchySwiper .swiper-button-next",
    prevEl: ".matchySwiper .swiper-button-prev",
  },
});

$(document).ready(function(){
$(document).on('click', '.tmenu_close', function(){
  
  $('.header__icon[aria-expanded="true"]').trigger('click');
});
$("span.tmenu_close.header__icon.header__icon--menu").click(function(){
  $(".menu-drawer-containerheade").removeClass("menu-opening");
});

});


        $(document).ready(function () {
            $(".price-button").click(function () {
                location.reload(true);
                // alert('Reloading Page');
            });
        });


/* Sorting script start */
  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }
  jQuery('#sort-by')
    .val('manual')
    .bind('change', function() {
      Shopify.queryParams.sort_by = jQuery(this).val();
      var url = '/collections/indian-wear?'+jQuery.param(Shopify.queryParams).replace(/\+/g, '%20'); 
      location.href = url;
    });
/* Sorting script end */
  

/* Filter script end */
  
